import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';

@Component({
  selector: 't4-JsonDialog',
  templateUrl: 'JsonDialog.html',
})
export class JsonDialog extends DialogBase {
  public json: string;
  public payload: any;

  constructor(public dialogRef: MatDialogRef<JsonDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
      super("JsonDialog");


    this.json = data.json;
    if (this.json) {
      this.payload = JSON.parse(this.json);
      this.json = JSON.stringify(this.payload, null, 2);
    }
  }

  public validate() {
    try {
      if (this.json == "") {
        this.dialogRef.close("");
        return;
      }

      var obj = JSON.parse(this.json);

      this.dialogRef.close(JSON.stringify(obj));
    } catch {
      this.UI.alert("T4.Common.Dialog.JsonDialog.InvalidJasonHead", "Invalid json", "T4.Common.Dialog.JsonDialog.InvalidJasonMessage", "The json you have entered is not valid");
    }
  }
}
